/**************************************************
 * Nombre:       Formulario_Informacion_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {Inventory2Outlined, Layers, ReportProblemOutlined} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";


const Formulario_Informacion_Producto = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >




                <Grid container size={12}>
                    <IngresoTexto Icono={Layers} nombre={'Titulo de la información'}
                                  dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={5} nombre={'Informacion'}
                                  dato={'descripcion'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Informacion_Producto